import { useSelector } from "react-redux";
import "./ToolUseRequest.scss";
import { chatSelectors } from "../../store/chatReducer";
import { Fragment, useState } from "react";
import Message from "../../../../../i18n/Message";
import {
  ChevronUpIcon,
  ChevronDownIcon,
  CheckCheckIcon,
  XIcon,
} from "lucide-react";
import MessageTextContainer from "../MessageTextContainer";
import CheckIcon from "../../../../../assets/icons/CheckIcon";
import ToolUseAction from "./toolUseAction";

const ToolUseRequest = ({
  toolUse,
  messageUid,
  pluginName,
  isExpanded = false,
  toolUseAction = null,
  requestApproval = false,
  toolResponse = null,
  allowActions = true,
  onApprove = () => {},
  onReject = () => {},
}) => {
  const [expanded, setExpanded] = useState(isExpanded);
  const [action, setAction] = useState(toolUseAction);
  const replyInProgress = useSelector(chatSelectors.getReplyInProgress);

  const input = toolUse.input ? JSON.parse(toolUse.input) : {};

  const onApproveClicked = (e, alwaysApprove) => {
    e.preventDefault();
    e.stopPropagation();
    setAction(
      alwaysApprove ? ToolUseAction.ALWAYS_APPROVE : ToolUseAction.APPROVE
    );
    onApprove(toolUse, alwaysApprove, messageUid);
  };

  const onRejectClicked = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setAction(ToolUseAction.REJECT);
    onReject(toolUse, messageUid);
  };

  console.log("toolUse render()", toolUse, allowActions);
  return (
    <div
      className="tool_use_block_container"
      onClick={() => setExpanded(!expanded)}
    >
      <div className="tool_use_block_header">
        <div className="tool_use_block_name">
          {toolUseAction &&
            (toolUseAction === ToolUseAction.AUTO_APPROVED ||
              toolUseAction === ToolUseAction.APPROVE) && (
              <div className="tool_use_action_badge approved">
                <CheckIcon size={14} color="#0a3622" strokeWidth="3" />
              </div>
            )}
          {toolUseAction && toolUseAction === ToolUseAction.REJECT && (
            <div className="tool_use_action_badge rejected">
              <XIcon size={14} />
            </div>
          )}
          <Message id="widget_use_tool_prefix" /> <b>{pluginName}</b>
          <div className="tool_name_badge">{toolUse.toolName}</div>
        </div>
        <div className="tool_use_right_side">
          {expanded && <ChevronUpIcon size={18} />}
          {!expanded && <ChevronDownIcon size={18} />}
        </div>
      </div>

      {expanded && (
        <div
          key={"tool-use-block-body-" + toolUse.toolUseId}
          className="tool_use_block_body"
        >
          {input && Object.keys(input).length > 0 && (
            <div className="params_table grid_table">
              <div className="table_header">
                <Message id="widget_tool_use_param" />
              </div>
              <div className="table_header">
                <Message id="widget_tool_use_value" />
              </div>
              {Object.keys(input).map((paramName) => {
                return (
                  <Fragment key={"tool-use-block-body-param-" + paramName}>
                    <div className="param_name table_cell name">
                      {paramName}
                    </div>
                    <div className="param_value table_cell description">
                      {input[paramName]}
                    </div>
                  </Fragment>
                );
              })}
            </div>
          )}
          {!toolUse.autoExec && !action && allowActions && !replyInProgress && (
            <div className="tool_use_buttons">
              <button
                className="btn bg-gradient-dark btn-sm"
                onClick={(e) => onApproveClicked(e, false)}
              >
                <CheckIcon size={18} color="#fff" strokeWidth="2" />
                <Message id="widget_tool_approve" />
              </button>
              <button
                className="btn btn-outline-dark btn-sm"
                onClick={(e) => onApproveClicked(e, true)}
              >
                <CheckCheckIcon size={18} />
                <Message id="widget_tool_always_approve" />
              </button>
              <button
                className="btn no-btn  btn-sm"
                onClick={(e) => onRejectClicked(e)}
              >
                <XIcon size={18} />
                <Message id="widget_tool_reject" />
              </button>
            </div>
          )}
          {(action || toolUse.autoExec) && (
            <div className="tool_use_action_container">
              {(toolUse.autoExec ||
                action === ToolUseAction.ALWAYS_APPROVE) && (
                <div className="tool_use_action approved">
                  <CheckCheckIcon size={18} color="#0a3622" strokeWidth="2" />
                  <Message id="tool_use_action_always_approved" />
                </div>
              )}
              {action === ToolUseAction.APPROVE && (
                <div className="tool_use_action approved">
                  <CheckIcon size={18} color="#0a3622" strokeWidth="2" />
                  <Message id="tool_use_action_approved" />
                </div>
              )}
              {action === ToolUseAction.REJECT && (
                <div className="tool_use_action rejected">
                  <XIcon size={18} />
                  <Message id="tool_use_action_rejected" />
                </div>
              )}
            </div>
          )}
          {toolResponse && (
            <div className="tool_use_response_body">
              <div className="tool_use_response_title">
                <Message id="widget_tool_use_response_title" />
              </div>
              <div className="tool_use_response_content">
                <MessageTextContainer>{toolResponse}</MessageTextContainer>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ToolUseRequest;
